import { useState } from 'react'
import { useOutletContext, useParams } from 'react-router-dom'

import { activateValidator } from '../../../api/applications.js'

const SERVICE_ACCOUNT_OPTIONS = [
  { value: 'appq', label: 'appq' },
  { value: 'adq', label: 'adq' },
  { value: 'veterans', label: 'veterans' },
  { value: 'morkwa', label: 'morkwa' },
]

export default function ApplicationValidatorPage() {
  const { id } = useParams()
  const { application, onApplicationUpdated } = useOutletContext()
  const [serviceAccount, setServiceAccount] = useState(
    application?.serviceAccount || SERVICE_ACCOUNT_OPTIONS[0].value
  )
  const [sharedKey, setSharedKey] = useState(application?.sharedKey ?? '')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState(null)
  const [successMessage, setSuccessMessage] = useState('')

  const isActive = application?.validatorEnabled === true
  const canEdit = !isActive

  async function handleSubmit(e) {
    e.preventDefault()
    if (!id || isSubmitting || !canEdit) return

    setError(null)
    setSuccessMessage('')
    setIsSubmitting(true)

    try {
      const updated = await activateValidator(id, {
        service_account: serviceAccount,
        shared_key: sharedKey.trim() || undefined,
      })
      onApplicationUpdated?.(updated)
      setSuccessMessage('Validator activated successfully.')
    } catch (err) {
      setError(err?.message ?? String(err))
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <section className="card sectionCard">
      <div className="cardTitle">Validator</div>

      {isActive && (
        <div className="validatorStatus validatorStatusActive" role="status">
          <span className="validatorStatusBadge">Validation enabled</span>
          {application?.serviceAccount && (
            <div className="validatorStatusAccount">Service account: {application.serviceAccount}</div>
          )}
        </div>
      )}

      {canEdit && (
        <form onSubmit={handleSubmit} className="validatorForm">
          <div className="formField">
            <label htmlFor="validator-service-account" className="formLabel">
              Service account
            </label>
            <select
              id="validator-service-account"
              className="textInput"
              value={serviceAccount}
              onChange={(e) => setServiceAccount(e.target.value)}
              required
            >
              {SERVICE_ACCOUNT_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
          <div className="formField">
            <label htmlFor="validator-shared-key" className="formLabel">
              Shared key <span className="muted">(optional)</span>
            </label>
            <input
              id="validator-shared-key"
              type="text"
              className="textInput"
              value={sharedKey}
              onChange={(e) => setSharedKey(e.target.value)}
              autoComplete="off"
            />
          </div>
          {error && (
            <p className="formError" role="alert">
              {error}
            </p>
          )}
          {successMessage && (
            <p className="settingsSuccess" role="status">
              {successMessage}
            </p>
          )}
          <div className="formActions">
            <button
              type="submit"
              className="button buttonPrimary"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Activating…' : 'Activate validator'}
            </button>
          </div>
        </form>
      )}
    </section>
  )
}
